module.exports = __webpack_public_path__ + "img/symbol_4.89451ea5.png";